export default function FormInput({
  label, // Label text
  value, // Input value
  onChange, // Called with new value string
  placeholder = "", // Placeholder text
  maxLength, // Max character length
  hint, // Optional hint text below input
  required = true, // Show red asterisk (default: true)
}) {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-2 border border-gray-300 rounded-md"
        maxLength={maxLength}
      />
      {hint && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
    </div>
  );
}
